import { render } from "./binderSection.vue?vue&type=template&id=7393a81b&scoped=true"
import script from "./binderSection.vue?vue&type=script&lang=js"
export * from "./binderSection.vue?vue&type=script&lang=js"

import "./binderSection.vue?vue&type=style&index=0&id=7393a81b&scoped=true&lang=css"

import exportComponent from "/data/PDBcov/VueJs/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7393a81b"]])

export default __exports__